const previousAcademicRecords = [
  {
    id: 'BCS221068',
    records: [
      { degree: 'Matric', obtainedMarks: 800, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 950, totalMarks: 1100, institute: 'Punjab College' },
    ],
  },
  {
    id: 'BBA221001',
    records: [
      { degree: 'Matric', obtainedMarks: 780, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 920, totalMarks: 1100, institute: 'City College' },
    ],
  },
  {
    id: 'BEE221002',
    records: [
      { degree: 'Matric', obtainedMarks: 820, totalMarks: 1050, institute: 'ABC High School' },
      { degree: 'Intermediate', obtainedMarks: 880, totalMarks: 1100, institute: 'Government College' },
    ],
  },
  {
    id: 'BSE221003',
    records: [
      { degree: 'Matric', obtainedMarks: 870, totalMarks: 1050, institute: 'Greenfield High School' },
      { degree: 'Intermediate', obtainedMarks: 910, totalMarks: 1100, institute: 'National College' },
    ],
  },
  {
    id: 'BME221004',
    records: [
      { degree: 'Matric', obtainedMarks: 790, totalMarks: 1050, institute: 'Sunrise High School' },
      { degree: 'Intermediate', obtainedMarks: 940, totalMarks: 1100, institute: 'Elite College' },
    ],
  },
  {
    id: 'BCS221005',
    records: [
      { degree: 'Matric', obtainedMarks: 810, totalMarks: 1050, institute: 'ABC High School' },
      { degree: 'Intermediate', obtainedMarks: 930, totalMarks: 1100, institute: 'Lahore College' },
    ],
  },
  {
    id: 'BCE221006',
    records: [
      { degree: 'Matric', obtainedMarks: 830, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 900, totalMarks: 1100, institute: 'Punjab College' },
    ],
  },
  {
    id: 'BSE221007',
    records: [
      { degree: 'Matric', obtainedMarks: 840, totalMarks: 1050, institute: 'Greenfield High School' },
      { degree: 'Intermediate', obtainedMarks: 910, totalMarks: 1100, institute: 'City College' },
    ],
  },
  {
    id: 'BCS221008',
    records: [
      { degree: 'Matric', obtainedMarks: 760, totalMarks: 1050, institute: 'Sunrise High School' },
      { degree: 'Intermediate', obtainedMarks: 950, totalMarks: 1100, institute: 'Government College' },
    ],
  },
  {
    id: 'BBA221009',
    records: [
      { degree: 'Matric', obtainedMarks: 790, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 940, totalMarks: 1100, institute: 'National College' },
    ],
  },
  {
    id: 'BEE221010',
    records: [
      { degree: 'Matric', obtainedMarks: 830, totalMarks: 1050, institute: 'ABC High School' },
      { degree: 'Intermediate', obtainedMarks: 920, totalMarks: 1100, institute: 'Lahore College' },
    ],
  },
  {
    id: 'BME221011',
    records: [
      { degree: 'Matric', obtainedMarks: 780, totalMarks: 1050, institute: 'Sunrise High School' },
      { degree: 'Intermediate', obtainedMarks: 950, totalMarks: 1100, institute: 'City College' },
    ],
  },
  {
    id: 'BCS221012',
    records: [
      { degree: 'Matric', obtainedMarks: 800, totalMarks: 1050, institute: 'Greenfield High School' },
      { degree: 'Intermediate', obtainedMarks: 890, totalMarks: 1100, institute: 'Government College' },
    ],
  },
  {
    id: 'BSE221013',
    records: [
      { degree: 'Matric', obtainedMarks: 820, totalMarks: 1050, institute: 'ABC High School' },
      { degree: 'Intermediate', obtainedMarks: 940, totalMarks: 1100, institute: 'Elite College' },
    ],
  },
  {
    id: 'BCE221014',
    records: [
      { degree: 'Matric', obtainedMarks: 850, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 910, totalMarks: 1100, institute: 'City College' },
    ],
  },
  {
    id: 'BBA221015',
    records: [
      { degree: 'Matric', obtainedMarks: 770, totalMarks: 1050, institute: 'Sunrise High School' },
      { degree: 'Intermediate', obtainedMarks: 930, totalMarks: 1100, institute: 'National College' },
    ],
  },
  {
    id: 'BME221016',
    records: [
      { degree: 'Matric', obtainedMarks: 800, totalMarks: 1050, institute: 'Greenfield High School' },
      { degree: 'Intermediate', obtainedMarks: 920, totalMarks: 1100, institute: 'Government College' },
    ],
  },
  {
    id: 'BCS221017',
    records: [
      { degree: 'Matric', obtainedMarks: 790, totalMarks: 1050, institute: 'ABC High School' },
      { degree: 'Intermediate', obtainedMarks: 950, totalMarks: 1100, institute: 'Lahore College' },
    ],
  },
  {
    id: 'BEE221018',
    records: [
      { degree: 'Matric', obtainedMarks: 830, totalMarks: 1050, institute: 'XYZ High School' },
      { degree: 'Intermediate', obtainedMarks: 900, totalMarks: 1100, institute: 'City College' },
    ],
  },
  {
    id: 'BSE221019',
    records: [
      { degree: 'Matric', obtainedMarks: 800, totalMarks: 1050, institute: 'Generic High School' },
      { degree: 'Intermediate', obtainedMarks: 900, totalMarks: 1100, institute: 'Generic College' },
    ],
  },
];

export default previousAcademicRecords;
